import { render, staticRenderFns } from "./ItDateInput.vue?vue&type=template&id=706692dc&scoped=true"
import script from "./ItDateInput.vue?vue&type=script&lang=ts"
export * from "./ItDateInput.vue?vue&type=script&lang=ts"
import style0 from "./ItDateInput.vue?vue&type=style&index=0&id=706692dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706692dc",
  null
  
)

export default component.exports